import { useDispatch, useSelector } from "react-redux";
import DealerDetails from "./DealerDetails";
import RequisitionValidation from "../RequisitionValidation";
import RequisitionAction from "../../../../../Store/Component/Requisition/RequisitionAction"
import { formatPrice } from "utils";
import { useEffect, useState } from "react";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import { getVendorDetails } from 'Store/Organization/VendorDetails/VendorDetailsAction';
import { CONSTANTS } from "client/utils/constants";

const DealerDetailsContainer = (props: any) =>{
    const reason = props?.reason;
    const dispatch = useDispatch();
    const setIsDealerChangesOccured = props?.setIsDealerChangesOccured;

     //selectors
    const { reasonList, managedEquipmentList, vendorDetails, isDealerSameForAllFlag }: any = useSelector((state?: any) => ({
        reasonList: state.RequisitionReducer.reasonList,
        managedEquipmentList: state.RequisitionReducer.managedEquipmentList,
        vendorDetails: state.VendorDetailsReducer.vendorDropDownList,
        isDealerSameForAllFlag : state.RequisitionReducer.isDealerSameForAllFlag
    }));

    const [vendorDropdownList, setVendorDropdownList] = useState<any>([]);
    const [loaded, setLoaded] = useState<any>(false);
    const [val, setVal] = useState<any>();
    const [isOnBlur, setIsOnBlur] = useState<any>(true);

    const [vendorSearchText, setVendorSearchText] = useState<string>("");
    const [vendor, setVendor] = useState<any>();
    const debouncedVendorSearchText = useDebounce(vendorSearchText, 500);

    useEffect(() => {
      dispatch(getVendorDetails("")); 
      setLoaded(true);
      setVendor({});
    }, [])

    useEffect(() => {
      ///Modified dropDown values as required
      const list = vendorDetails?.map((item: any) =>
        ({ text: item.alphaName, value: item.alphaName, label: item.abnumber + "-" + item.alphaName, key: item.abnumber, ...item })
        );

      setVendorDropdownList(list);
    }, [vendorDetails])


    const handleQuotePriceChange = (e: any, item: any, reason: any) => {
      dispatch(RequisitionAction.setIsChangesOccured(true))
      let valTemp = ({...reason, quotePrice: item.target.value})
      let responseReason = RequisitionValidation.ValidateReason({...valTemp});
      setVal(responseReason)
      setIsOnBlur(false)
      }
      const quotePriceFormat = (event: any, reason: any) => {
        setIsOnBlur(true)
        const value = event.target.value;
        let reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
        if (value !== "") {
          for (let i = 0; i < reasonListTemp.length; i++) {
            if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
              reasonListTemp[i].quotePrice = formatPrice(event.target.value, 2);
              let val = parseFloat(value?.replace(/,/g, "")).toFixed(2)
            let price = ((parseFloat(val))/100)*10
            const estimatedPriceValue  = ( price + parseFloat(val) )
            reasonListTemp[i].estimatedPrice = formatPrice(estimatedPriceValue, 2);
            let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
            reasonListTemp[i] = responseReason;
            }
          }
        }
        dispatch(RequisitionAction.setIReason(reasonListTemp))
        let previousprice = 0;
        for (let i = 0; i < reasonListTemp.length; i++) {
          if (reasonListTemp[i]?.requestIndex === reason?.requestIndex) {
            if(reasonListTemp[i]?.estimatedPrice){
              let val = parseFloat(reasonListTemp[i]?.estimatedPrice?.replace(/,/g, "")).toFixed(2)
             previousprice = previousprice + parseFloat(val);
            }
          }
        }
        let managedEquipmentListTemp = managedEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentList)) : [];
        for (let i = 0; i < managedEquipmentListTemp.length; i++) {
          if (managedEquipmentListTemp[i]?.requestIndex === reason?.requestIndex) {
            managedEquipmentListTemp[i].price = previousprice;
          }
        }
        dispatch(RequisitionAction.setIManagedEquipment(managedEquipmentListTemp));
      };

      const handleNameChange = (e: any, item: any, reason: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let reasonListTemp = reasonList?.length > 0 ? reasonList.map((currentReason: any) => ({ ...currentReason })) : [];
        for (let i = 0; i < reasonListTemp.length; i++) {
          if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
            reasonListTemp[i].name = item.target.value;
            let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
            reasonListTemp[i] = responseReason;
          }
        }
        dispatch(RequisitionAction.setIReason(reasonListTemp));
      }
      const handleContactChange = (e: any, item: any, reason: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let valTemp = ({...reason, contact: item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false)
    }
      const handlePhoneChange = (e: any, item: any, reason: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let valTemp = ({...reason, phone: item.target.value})
          let responseReason = RequisitionValidation.ValidateReason({...valTemp});
          setVal(responseReason)
          setIsOnBlur(false)
      }
      const handleEmailChange = (e: any, item: any, reason: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
          let valTemp = ({...reason, email: item.target.value})
          let responseReason = RequisitionValidation.ValidateReason({...valTemp});
          setVal(responseReason)
          setIsOnBlur(false)
      }
      const handleAddressLine1Change = (e: any, item: any, reason: any) => {
      dispatch(RequisitionAction.setIsChangesOccured(true))
        let valTemp = ({...reason, addressLine1: item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false)
    }
      const handleAddressLine2Change = (e: any, item: any, reason: any) => {
      dispatch(RequisitionAction.setIsChangesOccured(true));
        let valTemp = ({...reason, addressLine2: item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false)
    }
      const handleAddressLine3Change = (e: any, item: any, reason: any) => {
      dispatch(RequisitionAction.setIsChangesOccured(true))
        let valTemp = ({...reason, addressLine3: item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false)
    }
      const handleCityChange = (e: any, item: any, reason: any) => {
      dispatch(RequisitionAction.setIsChangesOccured(true));
        let valTemp = ({...reason, city: item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false)
    }
      const handleStateChange = (e: any, item: any, reason: any) => {
      dispatch(RequisitionAction.setIsChangesOccured(true));
        let valTemp = ({...reason, state: item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false)
    }
      const handleZipCodeChange = (e: any, item: any, reason: any) => {
      dispatch(RequisitionAction.setIsChangesOccured(true));
        let valTemp = ({...reason, zipCode: item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false)
      
    }

  const onChangeVendorName = (item: any) => {    
    setVendor(item);
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let reasonListTemp = reasonList?.length > 0 ? reasonList.map((currentReason: any) => ({ ...currentReason })) : [];
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex && reasonListTemp[i]?.requestIndex === reason?.requestIndex) {
        reasonListTemp[i].name = item.label;
        reasonListTemp[i].contact = item.mailingName;
        reasonListTemp[i].phone = item.phoneAreaCode + item.phoneNumber;
        reasonListTemp[i].contactError=item.phoneNumber ?  reasonListTemp[i]?.contactError: "";
        reasonListTemp[i].email = "";
        reasonListTemp[i].addressLine1 = item.address1;
        reasonListTemp[i].addressLine1Error="";
        reasonListTemp[i].addressLine2 = item.address2;
        reasonListTemp[i].addressLine2Error="";
        reasonListTemp[i].addressLine3 = item.address3;
        reasonListTemp[i].city = item.city;
        reasonListTemp[i].cityError="";
        reasonListTemp[i].state = item.state;
        reasonListTemp[i].stateError="";
        reasonListTemp[i].zipCode = item.postalCode;
        reasonListTemp[i].zipCodeError="";
        let response = RequisitionValidation.ValidateName({...reasonListTemp[i]});
        reasonListTemp[i] = response.reason;

        if(reasonListTemp[i]?.requestType === CONSTANTS.MANAGED_EQUIPMENT && isDealerSameForAllFlag){
          setIsDealerChangesOccured(true)
        }
      }
    }
    setVendorSearchText('')
    dispatch(RequisitionAction.setIReason(reasonListTemp));
    dispatch(getVendorDetails(''))
  }
  const filterOptionVendor = (value: any, action: any) => {
    if (action.action === "input-change") {
       setVendorSearchText(value) 
      } 
  };

  const dealerSelectOnBlur = () => {
    setVendorSearchText('')
  }

  useEffect(() => {
    if (loaded && debouncedVendorSearchText?.length > 2) {
      dispatch(getVendorDetails(debouncedVendorSearchText.replace(/[^\w\s]/gi,"")));
    } else {
      dispatch(getVendorDetails(''))
    }
  }, [debouncedVendorSearchText, loaded])

  useEffect(() => {
    if(reason?.name){
      setVendor({label : reason?.name, text: reason?.name.slice((reason?.name.indexOf('-'))+1), value: reason?.name.slice((reason?.name.indexOf('-'))+1)})
    }
    else{
      setVendor("")
    }
  }, [reason?.name])

    const [showDealerVendorPopup, setShowDealerVendorPopup] = useState(false)
    const dealerVendorPopupClick = (e:any) => {
      e.preventDefault();
      setShowDealerVendorPopup(true)
    }

    const OnBlurOfFields = (reason?: any) => {
        let reasonListTemp = reasonList?.length > 0 ? reasonList.map((currentReason: any) => ({ ...currentReason })) : [];
      for (let i = 0; i < reasonListTemp.length; i++) {
        if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
          reasonListTemp[i] = reason;
          let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
          reasonListTemp[i] = responseReason;
          if(reasonListTemp[i]?.requestType === CONSTANTS.MANAGED_EQUIPMENT && isDealerSameForAllFlag){
            setIsDealerChangesOccured(true)
          }
        }
      }
      setIsOnBlur(true)
      dispatch(RequisitionAction.setIReason(reasonListTemp));
    }
    
    return(
        <DealerDetails
       reason = {isOnBlur ? reason : val}
       handleQuotePriceChange = {handleQuotePriceChange}
       handleNameChange = {handleNameChange}
       handleContactChange = {handleContactChange}
       handlePhoneChange = {handlePhoneChange}
       handleEmailChange = {handleEmailChange}
       handleAddressLine1Change = {handleAddressLine1Change}
       handleAddressLine2Change = {handleAddressLine2Change}
       handleAddressLine3Change = {handleAddressLine3Change}
       handleCityChange = {handleCityChange}
       handleStateChange = {handleStateChange}
       handleZipCodeChange = {handleZipCodeChange}
       quotePriceFormat = {quotePriceFormat}
           showDealerVendorPopup={showDealerVendorPopup}
          dealerVendorPopupClick={dealerVendorPopupClick}
          setShowDealerVendorPopup={setShowDealerVendorPopup}
      //  onUploadClick = {onUploadClick}
      //  onAddAttachments = {onAddAttachments}
       //list = {list}
          vendorDropdownList={vendorDropdownList}
          onChangeVendorName={onChangeVendorName}
          filterOptionVendor={filterOptionVendor}
          vendor={vendor}
          dealerSelectOnBlur={dealerSelectOnBlur}
          vendorSearchText={vendorSearchText}
          OnBlurOfFields = {OnBlurOfFields}
       />
    )
}
export default DealerDetailsContainer;